import { Icon } from '@openeducation/oe-rn-components';
import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { IconButton } from 'react-native-paper';

import { useColors } from '../../hooks';

interface RatingStarsProps {
  value: number;
  onChange?: (value: number) => void;
  starsCount?: number;
  disabled?: boolean;
}

const RatingStars: React.FC<RatingStarsProps> = ({
  value,
  onChange,
  starsCount = 5,
  disabled = false,
}) => {
  const colors = useColors();
  const stars = useMemo(
    () =>
      new Array(starsCount).fill(null).map((_, index) => {
        const isActive = value >= index + 1;
        return (
          <IconButton
            key={index}
            style={style.star}
            onPress={() => onChange?.(index + 1)}
            disabled={disabled}
            color={isActive ? colors.oeAppSecondary : colors.gray}
            size={24}
            icon={(props) => (
              <Icon
                name="star"
                type={isActive ? 'solid' : 'regular'}
                {...props}
              />
            )}
          />
        );
      }),
    [starsCount, value, onChange, colors, disabled]
  );

  return <View style={style.container}>{stars}</View>;
};

const style = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  star: {
    opacity: 1,
  },
});

export default RatingStars;
